// src/components/common/GameSeasonFilterModal.jsx
import React, { useState, useEffect } from 'react';

const GameSeasonFilterModal = ({ isOpen, onClose, onApply, initialSeason, availableSeasons }) => {
  const [season, setSeason] = useState(initialSeason || '');

  useEffect(() => {
    setSeason(initialSeason || '');
  }, [initialSeason]);

  if (!isOpen) return null;

  const handleApply = () => {
    onApply(season);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm">
        <h2 className="text-lg font-semibold mb-4">Filter by Season</h2>
        <div className="space-y-4">
          <div>
            <label htmlFor="season" className="block text-sm font-medium text-gray-700">Season</label>
            <div className="flex items-center mt-1">
              <select
                id="season"
                value={season}
                onChange={(e) => setSeason(e.target.value)}
                className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              >
                <option value="">All Seasons</option>
                {availableSeasons.map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
              {season && (
                <button
                  onClick={() => setSeason('')}
                  className="ml-2 text-red-500 hover:text-red-700"
                  aria-label="Clear season"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameSeasonFilterModal;
